import type { Column } from "@/types/array.types";
import type { Database } from "@/types/database.types";
import { formatDateDisplay } from "@/utils/date";
import { type SortOption } from "../../view-model/viewModel";

export type ArtType = Database["public"]["Tables"]["art"]["Row"];
type ArtWithImage = ArtType & {
    imageUrl?: string;
  };
export type ArtInsert = Database["public"]["Tables"]["art"]["Insert"];
export type ArtUpdate = Database["public"]["Tables"]["art"]["Update"];

export const columns = [
    {
        key: "document_id", 
        label: "Photo",
        render: (row) => (
            row.imageUrl 
              ? <img src={row.imageUrl} className="table-image" />
              : "-"
          )
    }, 
    {key: "artist", label: "Artiste"}, 
    {key: "description", label: "Description", render: (row) => row.description == null ? "" : row.description}, 
    {
        key: "price", 
        label: "Prix", 
        validate: (value) => {
        if (value && isNaN(Number(value))) {
        return "Le prix doit être un nombre.";
        }
        return null;
        },
    }, 
    {key: "assurance_location", label: "Assurance"}, 
    {
        key: "creation_date", 
        label: "Création", 
        render: (row) =>
        formatDateDisplay(row.creation_date),
        validate: (value) => {
            return value && isNaN(Date.parse(String(value)))
                ? "La date est invalide."
                : null;
            },
        renderLabel: (row) =>
            row?.creation_date && formatDateDisplay(new Date(row.creation_date))
        }, 
    {key: "comment", label: "Commentaire", render: (row) => row.comment == null ? "" : row.comment},
    {key: "id", label: "id"}
] as Column<ArtWithImage>[];

export const filters = [
        {key: "artist", label: "Artiste"},  
        {key: "assurance_location", label: "Assurance"}
    ] as Column<ArtType>[];

export const sortOptions = [
    {
        key: "artist",
        label: "Par artistes",
        by: "croissant"
    },
    {
        key: "price",
        label: "Prix croissant",
        by: "croissant"
    },
    {
        key: "price",
        label: "Prix décroissant",
        by: "décroissant"
    },
    {
        key: "created_at",
        label: "Plus récent",
        by: "décroissant"
    },
    {
        key: "created_at",
        label: "Plus ancien",
        by: "croissant"
    },
] as SortOption[];

export const columnsExport = ["Artiste", "Description", "Prix", "Assurance", "Création", "Commentaire"];


